import React from 'react';

import { useModal } from 'context/ModalContext';
import { useWelcomeCoupon } from 'entities/coupon';
import { ArrowRight, Ticket } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getPathWithoutLang } from 'shared/lib/converter';
import { useInfoStore } from 'store/useInfoStore';

const ProfileCompletionBanner = () => {
  const { isLogin, profileCompleted } = useInfoStore();
  const { eligible } = useWelcomeCoupon();
  const { t } = useTranslation('auth');
  const { openModal, MODAL_TYPES } = useModal();
  const { pathname } = useLocation();
  const path = getPathWithoutLang(pathname);

  if (!isLogin || profileCompleted || !eligible) return null;
  if (path !== '/') return null;

  return (
    <aside className="flex items-center justify-center gap-x-4 bg-primaryLight px-4 py-1">
      <p className="hidden text-c2 text-gray-50 min-[800px]:block">
        {t(eligible ? 'onboarding.banner' : 'onboarding.accountReady')}
      </p>
      <button
        type="button"
        onClick={() => openModal(MODAL_TYPES.ONBOARDING)}
        className="flex min-h-11 items-center justify-center gap-2 py-2 text-left text-[14px] font-medium leading-5 text-primary min-[800px]:font-semibold min-[800px]:underline min-[800px]:underline-offset-4"
      >
        <Ticket size={18} className="shrink-0 min-[800px]:hidden" aria-hidden="true" />
        <span>{t(eligible ? 'onboarding.start' : 'onboarding.title')}</span>
        <ArrowRight size={16} className="shrink-0 min-[800px]:hidden" aria-hidden="true" />
      </button>
    </aside>
  );
};

export default ProfileCompletionBanner;
